export function loadScript(scriptUrl) {

    if (!isScriptLoaded(scriptUrl)) {
        //console.log('script load');

        console.log('Loading script: ' + scriptUrl);
        const script = document.createElement('script');
        script.src = scriptUrl;
        //script.setAttribute('data-key','publish key');
        /*
        args.attributes.map(
            attr =>
                script.setAttribute(attr.name, attr.value)
        )
        */
        //console.log(script);
        document.body.appendChild(script);

        //console.log('running script');

        // }, 2000
        // )
    }
}

export function isScriptLoaded(src) {
    return document.querySelector('script[src="' + src + '"]') ? true : false;
}